import { LiItem } from "@faire/help-center-self-serve/brand/instantAnswers/instantAnswersComponents/common/LiItem";
import retailerSettingsProfile from "@faire/web-api/routes/retailer/settings/profile";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Bold } from "@faire/web/ui/Typography/Span";
import React from "react";
export var ResetOrUpdatePasswordIA = function ResetOrUpdatePasswordIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qQ6HjO",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez gérer votre mot de passe de deux façons :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4bZNDG",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez oublié votre mot de passe, vous pouvez le réinitialiser :"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1ShK6n",
    defaultMessage: [{
      "type": 0,
      "value": "Cliquez sur "
    }, {
      "children": [{
        "type": 0,
        "value": "Se connecter"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " en haut à droite de la page d'accueil."
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "A45LYr",
    defaultMessage: [{
      "type": 0,
      "value": "Saisissez votre adresse e-mail et appuyez sur Entrée."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yaYwDM",
    defaultMessage: [{
      "type": 0,
      "value": "Cliquez sur "
    }, {
      "children": [{
        "type": 0,
        "value": "Mot de passe oublié ? Réinitialiser"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3dToYM",
    defaultMessage: [{
      "type": 0,
      "value": "Vérifiez votre boîte de réception (et le dossier de spam) et recherchez le lien de réinitialisation du mot de passe."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "l36AqR",
    defaultMessage: [{
      "type": 0,
      "value": "Suivez les instructions contenues dans l'e-mail pour réinitialiser votre mot de passe."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Rp+OL4",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous connaissez votre mot de passe actuel, vous pouvez le mettre à jour :"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3bw68g",
    defaultMessage: [{
      "type": 0,
      "value": "Accédez à la page "
    }, {
      "children": [{
        "type": 0,
        "value": "Paramètres"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      AccountSettingLinkFormatting: AccountSettingLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Lv/yn9",
    defaultMessage: [{
      "type": 0,
      "value": "Accédez à "
    }, {
      "children": [{
        "type": 0,
        "value": "Mon profil"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  })), " "), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EaN/2z",
    defaultMessage: [{
      "type": 0,
      "value": "Accédez à la section "
    }, {
      "children": [{
        "type": 0,
        "value": "Mot de passe"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " et suivez les instructions pour modifier votre mot de passe."
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nUHkRv",
    defaultMessage: [{
      "type": 0,
      "value": "En cas de problème de réinitialisation ou de mise à jour de votre mot de passe, contactez-nous par l'un des canaux ci-dessous."
    }]
  })));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var AccountSettingLinkFormatting = function AccountSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: retailerSettingsProfile(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};